import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { TileDatagrid } from '../../../../../dis-v2/_components/TileDatagrid'

import { getFilteredRows } from '../../../../../../data/dataHelpers'

export function BasicDatagridComponent(props) {
	const { selectedJobIdSearch, tile, gridColumns, allRows, gridLoading } = props

	const { environment } = useSelector((state) => state)
	const [t] = useTranslation()

	const filterModel = useMemo(() => {
		const filters = []
		if (selectedJobIdSearch) {
			filters.push(selectedJobIdSearch)
		}

		return filters
	}, [selectedJobIdSearch])

	const displayRows = useMemo(() => {
		return getFilteredRows(filterModel, allRows)
	}, [allRows, filterModel])

	return (
		<TileDatagrid
			tile={tile}
			columns={gridColumns}
			rows={displayRows}
			isLoading={gridLoading}
			printTitle={t('common:input.jobTasks')}
		/>
	)
}
